module.exports = __webpack_public_path__ + "img/grad.84fb9684.jpg";